<div class="cintaInferior">
  <div class="container spaceContainer">
    <div class="contenedorCintaInferior">
      <img tabindex="0" class="logoCol" alt="Logo Colombia" matTooltip="Logo Colombia"
           src="../../../assets/img/cinta/marca-colombia-cinta-inferiorTransparente.png">
      <img tabindex="0" class="logoGovInferior" alt="Logo Gov Co" matTooltip="Logo gobierno de Colombia"
           src="../../../assets/img/cinta/logo-gov-cinta-superior-e-inferiorTransparente.png">
    </div>
  </div>
</div>
